import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthContext';

export const FOREMAN_REFRESH_INTERVAL_MS=30_000;

export function ForemanQueryRefresh(){
  const{user}=useAuth();const queryClient=useQueryClient();
  useEffect(()=>{
    if(user?.role!=='FOREMAN')return;
    const timer=window.setInterval(()=>{if(queryClient.isMutating()===0)void queryClient.refetchQueries({type:'active'});},FOREMAN_REFRESH_INTERVAL_MS);
    return()=>window.clearInterval(timer);
  },[queryClient,user?.role]);
  return null;
}
